import React from 'react';

import ProductCardsSection from "./productCardsSection";
// import Banner from "./banner";
import NotebooksJournalsSection from "./NotebooksJournalsSection";
import PromotionalSection from "./PromotionalSection";
import DifferentiatorsSection from "./DifferentiatorsSection";
import ClientSuccessSection from "./ClientSuccessSection";
// import ProductSliderSection from "./ProductSliderSection";
import FaqSection from "./FaqSection";
import CorporateInquiry from "./CorporateInquiry";
import Video from "./Video";
import rakhi from "./Rakhi";
import Rakhi from './Rakhi';
const Home = () => {
  
  return (
    <div>
   
   
     <Rakhi />
      <ProductCardsSection />
        <Video />
      <NotebooksJournalsSection />
     
      <PromotionalSection />
      {/* <ProductSliderSection /> */}
      <ClientSuccessSection />
      
      {/* <DifferentiatorsSection /> */}
     <section id="corporate-enquiry">
  <CorporateInquiry />
</section>
      <FaqSection />
    </div>
  );
};

export default Home;